// extracted by mini-css-extract-plugin
module.exports = {"headerHasRibbon":"CartDropdown_headerHasRibbon__fneck","cardDropdown":"CartDropdown_cardDropdown__3BqnU"};